import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import MasterData from '../../data/MasterData'

const RouteMapKindModal = ({ themeName, closeKindModal }) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const locale = intl.locale

  useEffect(() => {
    return () => {
      closeKindModal()
    }
  }, [closeKindModal])

  const handleCloseClick = (e) => {
    navigate(-1)
  }

  return (
    <div className="c-Modal">
      <div className="c-Modal-dialog">
        <div className="c-Modal-header is_default">
          <p className="c-Modal-headerTitle"><FormattedMessage id='App.RouteMap.kindModal.title' /></p>
          <div className="c-Modal-headerClose" onClick={handleCloseClick}></div>
        </div>
        {/*<!-- MEMO: 種別アイコンカラー
          .is_jr → JR線直通（ミドリ）
          .is_limitedExpress → 特急（オレンジ）
          .is_express → 急行（赤）
          .is_rapid → 快速（水色）
          .is_local → 各停（グレー）
        -->*/}

        <div className="d-RoutemapKindModal-body">
          <ul className="d-RoutemapKindModal-list">
            <li className="d-RoutemapKindModal-listItem">
              <span className="d-RoutemapKindModal-pattern is_jr"></span>
              {MasterData.trainKindById(0)[`routemap_name_${locale}`]}
              ・
              {MasterData.trainKindById(4)[`routemap_name_${locale}`]}
              （<FormattedMessage id="App.TrainPositions.thruToJR" values={{br: ''}} >{(...c) => c}</FormattedMessage>）
            </li>
            <li className="d-RoutemapKindModal-listItem">
              <span className="d-RoutemapKindModal-pattern is_tokyuShinyokohama"></span>
              {MasterData.trainKindById(0)[`routemap_name_${locale}`]}
              ・
              {MasterData.trainKindById(4)[`routemap_name_${locale}`]}
              （<FormattedMessage id="App.TrainPositions.thruToTokyu" values={{br: ''}} >{(...c) => c}</FormattedMessage>）
            </li>
            <li className="d-RoutemapKindModal-listItem">
            <span className="d-RoutemapKindModal-pattern is_limitedExpress"></span>
              {MasterData.trainKindById(0)[`routemap_name_${locale}`]}
              ・
              {MasterData.trainKindById(5)[`routemap_name_${locale}`]}
            </li>
            <li className="d-RoutemapKindModal-listItem">
              <span className="d-RoutemapKindModal-pattern is_express"></span>
                {MasterData.trainKindById(6)[`routemap_name_${locale}`]}
            </li>
            <li className="d-RoutemapKindModal-listItem">
              <span className="d-RoutemapKindModal-pattern is_rapid"></span>
                {MasterData.trainKindById(2)[`routemap_name_${locale}`]}
            </li>
            <li className="d-RoutemapKindModal-listItem">
              <span className="d-RoutemapKindModal-pattern is_local"></span>
              {MasterData.trainKindById(4)[`routemap_name_${locale}`]}
            </li>
          </ul>

          <ul className="d-RoutemapKindModal-note">
            <li><FormattedMessage id='App.RouteMap.kindModal.noteComLtdExpAndComExpStops' /></li>
            <li><FormattedMessage id='App.RouteMap.kindModal.noteComLtdExpStops' /></li>
          </ul>
        </div>
      </div>
    </div>
  )
}

RouteMapKindModal.propTypes = {
  themeName: PropTypes.string.isRequired,
  closeKindModal: PropTypes.func.isRequired,
}

export default RouteMapKindModal
